module.exports = __webpack_public_path__ + "static/thumbnail-d8ea6cd05363d1ce6132c504c01938fe.png";